import React from "react";
import styles from "./Hero.module.css";
import {
  FaArrowRight,
  FaBuilding,
  FaPaperPlane,
  FaShieldAlt,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className={styles.hero}>
      <div className={styles.container}>
        <div className={styles.left}>
          <h1 className={styles.heading}>
            Hire <span className={styles.highlight}>Smarter</span> with the Best
            Talent Acquisition
            <span className={styles.highlight}> Platform</span>
          </h1>
          <p className={styles.subheading}>
            Simplify your hiring process, attract top talent, and build strong
            teams — all from one powerful platform.
          </p>

          <div className={styles.ctaButtons}>
            <button
              className={styles.heroRequestBtn}
              onClick={() => navigate("/contact-us")}
            >
              <FaPaperPlane className={styles.ctaIcon} />
              Request a Demo
            </button>

            <button
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/contact-us")}
              className={styles.heroRequestBtn}
            >
              <FaArrowRight className={styles.ctaIcon} />
              Get Started
            </button>
          </div>
          {/* Ratings Section */}
          <div className={styles.ratings}>
            {/* <div className={styles.ratingItem}>
              <span className={styles.ratingBadge}>
                <FaStar className={styles.starIcon} /> 4.8/5
              </span>
              <p>
                <FaGlobe className={styles.platformIcon} /> Global Reviews
              </p>
              <small>Trusted by recruiters & HR teams in 20+ countries</small>
            </div> */}

            <div className={styles.ratingItem}>
              <span className={styles.ratingBadge}>
                <FaUsers className={styles.starIcon} /> 100K+
              </span>
              <p>
                <FaUserTie className={styles.platformIcon} /> Active
                Professionals
              </p>
              <small>Skilled candidates across tech, design, and sales</small>
            </div>

            <div className={styles.ratingItem}>
              <span className={styles.ratingBadge}>
                <FaBuilding className={styles.starIcon} /> 1K+
              </span>
              <p>
                <FaShieldAlt className={styles.platformIcon} /> Verified
                Companies
              </p>
              <small>From startups to global enterprises</small>
            </div>

            {/* <div className={styles.ratingItem}>
              <span className={styles.ratingBadge}>
                <FaChartBar className={styles.starIcon} /> 92%
              </span>
              <p>
                <FaCheckCircle className={styles.platformIcon} /> User
                Satisfaction
              </p>
              <small>Faster hiring & better candidate matching</small>
            </div> */}
          </div>
        </div>

        <div className={styles.right}>
          <img
            src="/heroPerson.webp"
            alt="Hero person"
            width="600"
            height="600"
            loading="eager"
            fetchpriority="high"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
